import { defineStore } from "pinia";

// Dados do cadastro em andamento entre os passos (informações, apelido)
export const useRegisterStore = defineStore("register", {
  state: (): { data: any | null } => ({ data: null }),
  persist: true,
  actions: {
    save(data: any) {
      this.data = data;
    },
    update(data: any) {
      this.data = { ...(this.data || {}), ...data };
    },
    clear() {
      this.data = null;
    },
  },
});
